export * from './virtual-assistant.component';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/virtual-assistant/index.ts